import { render } from "./CardapioHeader.vue?vue&type=template&id=0542eb54"
import script from "./CardapioHeader.vue?vue&type=script&lang=js"
export * from "./CardapioHeader.vue?vue&type=script&lang=js"

import "./CardapioHeader.vue?vue&type=style&index=0&id=0542eb54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__